<div class="format-filters">
  <div *ngIf="traditionalFilterKeys.length" class="traditional-formats">
    <div class="format-filters__wrapper">
      <ng-container *ngFor="let elem of traditionalFilterKeys">
        <button
          mat-flat-button
          class="btn-icon-text"
          [opacTooltip]="filterFormatInfoMap.get(elem).label | translate"
          [class.selected]="elem.name === selectedFilter"
          (click)="applyFilter(filter.name, elem.name)">
          <span [className]="filterFormatInfoMap.get(elem).className.concat(' filter-icon')" aria-hidden="true"
            >{{ filterFormatInfoMap.get(elem).icon }}</span
          >
          <span class="text" aria-hidden="true">{{ elem.value }}</span>

          <span class="odilo-icon close-icon" aria-hidden="true">close</span>
        </button>
      </ng-container>
    </div>
  </div>

  <div *ngIf="physicalFilterKeys.length > 0" class="physical-formats">
    <div class="format-filters__wrapper">
      <ng-container *ngFor="let elem of physicalFilterKeys">
        <button
          mat-flat-button
          class="btn-icon-text"
          [opacTooltip]="filterFormatInfoMap.get(elem).label | translate"
          [class.selected]="elem.name === selectedFilter"
          (click)="applyFilter(filter.name, elem.name)">
          <span [className]="filterFormatInfoMap.get(elem).className.concat(' filter-icon')" aria-hidden="true"
            >{{ filterFormatInfoMap.get(elem).icon }}</span
          >
          <span class="text" aria-hidden="true">{{ elem.value }}</span>

          <span class="odilo-icon close-icon" aria-hidden="true">close</span>
        </button>
      </ng-container>
    </div>
  </div>

  <div *ngIf="experiencesFilterKeys.length > 0" class="experiences-formats">
    <div class="format-filters__wrapper">
      <ng-container *ngFor="let elem of experiencesFilterKeys">
        <button
          mat-flat-button
          class="btn-icon-text"
          [opacTooltip]="filterFormatInfoMap.get(elem).label | translate"
          [class.selected]="elem.name === selectedFilter"
          (click)="applyFilter(filter.name, elem.name)">
          <span [className]="filterFormatInfoMap.get(elem).className.concat(' filter-icon')" aria-hidden="true"
            >{{ filterFormatInfoMap.get(elem).icon }}</span
          >
          <span class="text" aria-hidden="true">{{ elem.value }}</span>

          <span class="odilo-icon close-icon" aria-hidden="true">close</span>
        </button>
      </ng-container>
    </div>
    <div class="experiences-formats__info-button-wrapper">
      <button
        class="btn-icon-text"
        mat-flat-button
        [attr.aria-label]="'tooltip.info' | translate"
        (click)="openExperiencesInfoDialog()">
        <span class="odilo-icon" aria-hidden="true">info</span>
      </button>
    </div>
  </div>
</div>
